import { stringify } from 'query-string';
import { template } from 'lodash';
import axios from './client';

const USER_CARD = template('/user/<%= id %>/card');
const PAYMENTS = '/payment';
const PAYMENTS_FAILED = '/payment-failed';
const MAKE_PAYMENT = template('/invoice/<%= id %>');
const STATUS_PAYMENT = template('/payment-intent/<%= id %>');

/**
 * Get all contractor's cards
 * @returns {Promise}
 */
export function getUserCard(id) {
  return axios.get(USER_CARD({ id }), { timeout: 0 });
}

export function payments(params = {}) {
  return axios.get(PAYMENTS, { params });
}

export function paymentsFailed(params = {}) {
  return axios.get(PAYMENTS_FAILED, { params });
}

export function makePayment(id, params = {}) {
  const data = stringify(params);
  return axios.post(MAKE_PAYMENT({ id }), data);
}

export function updateStatusInvoice(id, params = {}) {
  const data = stringify(params);
  return axios.post(STATUS_PAYMENT({ id }), data);
}

export function userActionWithCard(id, mode, params = {}) {
  const data = stringify(params);
  const param = `?mode=${mode}`;
  return axios.post(USER_CARD({ id }) + param, data, { timeout: 0 });
}
